<template>
  <div v-if="showAsList ? tags.length : allTags.length" class="locations-tags mt-60" :class="{ 'show-as-list': showAsList }">
    <h3 class="vz-text-align-left">
     {{ title }}
    </h3>
    <div class="locations-tags-wrapper flex flex-wrap mt-20">
      <template v-if="showAsList">
        <div v-for="(tag, index) in tags" class="locations-tags-tag">
          {{ tag.name }}
        </div>
      </template>
      <template v-else>
        <vz-button
          big
          icon-right
          v-for="(tag, index) in allTags"
          :key="index"
          icon-size=20
          class="mr-20 mb-20"
          target="_blank"
          variant="primary"
          icon-name="arrow-right"
          :to="getLink(tag.translit)"
        >
          {{ tag.name }}
        </vz-button>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
import { useCityStore } from "~/stores/city"
import { PublicLocationsTag } from "~~/types/public"
import { BASE_URL_HTTPS } from '~/composables/useVzFetch'
import { Location } from "~/types/types"
import { PropType } from "vue"

const props = defineProps({
  title: {
    type: String,
    default: 'Грузоперевозки из других городов'
  },
  location: {
    type: Object as PropType<Location>,
    default: () => {}
  },
  tags: {
    type: Array as PropType<PublicLocationsTag[]|Location[]>,
    default: () => []
  },
  showAsList: {
    type: Boolean,
    default: false
  }
})

const { rclCityList } = storeToRefs(useCityStore())

// cоседние по списку города
const nearbyTags = computed(() => {
  if (props.location) {
    const guid = props.location.rcl_guid || props.location.guid

    let index = rclCityList.value.findIndex(item => item.guid === guid)
    index = Math.abs(index)
    
    const prev = index === 0
      ? rclCityList.value[index + 1]
      : ((index  === rclCityList.value.length - 1)
        ? rclCityList.value[index - 2]
        : rclCityList.value[index - 1])
    const next = index === 0
      ? rclCityList.value[index + 2]
      : ((index  === rclCityList.value.length - 1)
        ? rclCityList.value[index - 1]
        : rclCityList.value[index + 1])
    return [prev, next]
  } 
  return []
})

const allTags = computed(() => {
  return [...props.tags, ...nearbyTags.value]
})

function getLink(url: string) {
  return `${BASE_URL_HTTPS}/order/create/${url}/`
}
</script>

<style lang="scss" scoped>
.locations-tags {
  &.show-as-list {
    h3 {
      font-size: 24px;
      line-height: 30px;
      color: $font-dark;
    }

    .locations-tags-wrapper {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
      margin-top: 30px;

      @media screen and (max-width: $pub-sm) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media screen and (max-width: $pub-xs) {
        grid-template-columns: 1fr;
      }
    }

    .locations-tags-tag {
      position: relative;
      color: $font-low;
      padding-left: 15px;

      &:before {
        position: absolute;
        content: '.';
        top: -12px;
        left: 0px;
        font-size: 40px;
      }
    }
  }
}
</style>
